import { baseSplitApi as api } from "./baseApi";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    deleteBackOfficeMedia: build.mutation<
      DeleteBackOfficeMediaApiResponse,
      DeleteBackOfficeMediaApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/bo/media/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bigsystherApi };
export type DeleteBackOfficeMediaApiResponse =
  /** status 200 OK */ SuccessResponse200;
export type DeleteBackOfficeMediaApiArg = {
  /** uuid */
  id: string;
};
export type SuccessResponse200 = {
  status?: string;
};
export type ValidationError = {
  field?: string;
  message?: string;
};
export type ErrorResponse400 = {
  code?: number;
  data?: ValidationError[];
  message?: string;
};
export type ErrorResponse404 = {
  code?: number;
  data?: {
    [key: string]: string;
  }[];
  message?: string;
};
export const { useDeleteBackOfficeMediaMutation } = injectedRtkApi;
